import { useParams } from "react-router";
import { useSelector } from "react-redux";

import { BAND_PATHS } from "Bands/router";
import { useEventRoute } from "Bands/utils";
import { dataMetaSelector, eventBlockSelectorCreator } from "Bands/state";
import { copy } from "shared/assets";
import { Plane } from "shared/assets/icons";
import { Button, Card, Loader } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, ITheme } from "shared/types";
import { BAND_ACTIONS, EventBlocks, IEventTravelBlock } from "Bands/types";
import { FourOhFour, FourOhThree } from "shared/pages";
import { mapUserPermissions } from "shared/utils";
import { EventTravelLegs } from "Bands/containers";
import { AddPassenger, AddTravelLeg, TravelMap } from "./containers";
import CopyBlockModal from "../copy-block/CopyBlockModal";

const blockCopy = copy.travelBlock.edit;

export const EditTravelBlockPage = () => {
  const { pushRoute } = useEventRoute();
  const { blockId } = useParams<{ blockId: string }>();

  const blockSelector = eventBlockSelectorCreator(blockId, EventBlocks.travel);
  const block = useSelector(blockSelector) as IEventTravelBlock;

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.getEventTravelBlocks));

  const renderContent = () => {
    if (!block) return <Loader />; // fetching

    return (
      <Spacer size="l">
        <CopyBlockModal blockType={EventBlocks.travel} deleteBlockId={blockId} />
        <TravelMap travelLegs={block.travelLegs} />
        <AddTravelLeg blockId={blockId} />
        {!!block.travelLegs.length && (
          <EventTravelLegs showActions blockId={blockId} travelLegs={block.travelLegs} />
        )}
        <AddPassenger blockId={blockId} travelLegs={block.travelLegs} />
        <Button onClick={() => pushRoute(BAND_PATHS.BAND_EVENT)} theme={ITheme.secondary}>
          {copy.form.finish}
        </Button>
      </Spacer>
    );
  };

  if (apiMeta?.status !== IAPIState.pending && !block) return <FourOhFour />;

  if (block && !mapUserPermissions(block.permissions || []).EDIT) {
    return <FourOhThree />;
  }

  return (
    <Card title={blockCopy.title.replace("%title", block?.title || "...")} icon={Plane}>
      {renderContent()}
    </Card>
  );
};
